<template>
  <v-container class="pa-0">
    <v-row no-gutters justify="center">
      <v-col cols="12" sm="9" class="text-center">
        <v-btn
          style="width: 83%;"
          color="primary"
          class="mt-11 mb-4"
          tile
          :loading="isAuthenticating"
          :disabled="isAuthenticating"
          @click="startAuthentication"
        >
          <span style="font-weight: bold; width: 90%;">{{ $t('beginAuthenticationText') }}</span>
        </v-btn>

        <div style="color: #333; margin-top: 12px; text-align: left; padding-left: 6%;">
        {{ $t('authenticationInformationText') }}
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      isAuthenticating: false
    }
  },
  methods: {
    async startAuthentication() {
      if (this.isAuthenticating) return

      this.isAuthenticating = true
      this.$store.commit('setsignicatAuthenticated', false)

      try {
        await this.$store.dispatch('getAuthenticationUrlForLogin')
      } finally {
        this.isAuthenticating = false
      }
    }
  }
}
</script>

<i18n>
  {
  "fi": {
  "authenticationInformationText": "Tunnistautuminen tapahtuu Signicat-palvelun avulla.\nOnnistuneen tunnistautumisen jälkeen sinut ohjataan takaisin\nOma B2 Impact -palveluun.",
  "beginAuthenticationText": "Aloita tunnistautuminen"
  },
  "se": {
  "authenticationInformationText": "Identifieringen utförs med hjälp av Signicat-tjänsten.\nEfter lyckad identifiering omdirigeras du tillbaka till\nOma B2 Impact-tjänsten.",
  "beginAuthenticationText": "Börja autentisering"
  },
  "en": {
  "authenticationInformationText": "Identification is carried out using the Signicat service.\nAfter successful identification, you will be redirected back to the\nOma B2 Impact service.",
  "beginAuthenticationText": "Begin authentication"
  }
  }
</i18n>
